


































































































































































































import Vue, { PropType } from 'vue';
import * as InputValidation from '@/mixins/inputValidation';

import store from '@/store';

import { BaseOrganization, BasePeerGroup, WebRequestStatus } from '@/models';

import PersistableItem from '@/components/PersistableItem.vue';
import PeerGroupSettingsRoleEditor, {
  normalizeAgainstOrg,
  RoleNameUpdateEvent
} from '@/components/PeerGroupSettingsRoleEditor.vue';

export interface UpdatedSettings {
  peerGroupId: number;
  name: string;
  section: string;
  description: string;
  creatorCanPublish: boolean;
  teachersCanPublish: boolean;
  submissionStatusIsInteractive: boolean;
  organizationSyncAssignments: boolean;
  roleNameStudent: string | null;
  roleNameStudentPlural: string | null;
  roleNameTeacher: string | null;
  roleNameTeacherPlural: string | null;
}

export default Vue.extend({
  components: {
    PersistableItem,
    PeerGroupSettingsRoleEditor
  },

  props: {
    peerGroup: {
      type: Object as PropType<BasePeerGroup>,
      required: true
    },
    organization: {
      type: Object as PropType<BaseOrganization>,
      required: true
    }
  },

  data() {
    return {
      roleNamesAreChanged: false,
      updatedRoleNames: normalizeAgainstOrg(this.peerGroup, this.organization),
      nameInput: this.peerGroup.name,
      sectionInput: this.peerGroup.section,
      descriptionInput: this.peerGroup.description,
      creatorCanPublishInput: this.peerGroup.creatorCanPublish,
      teachersCanPublishInput: this.peerGroup.teachersCanPublish,
      submissionStatusIsInteractive: this.peerGroup
        .submissionStatusIsInteractive,
      organizationSyncAssignmentsInput: this.peerGroup
        .organizationSyncAssignments
    };
  },

  computed: {
    status(): WebRequestStatus {
      return store.state.org.activeRequests.group.getStatus(
        this.peerGroup.peerGroupId
      );
    },

    nameValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.nameInput, 250, true);
    },

    sectionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.sectionInput, 250, false);
    },

    descriptionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.descriptionInput, 250, false);
    },

    creatorLabel(): string {
      return this.creatorCanPublishInput ? 'Allowed' : 'Not Allowed';
    },

    teachersLabel(): string {
      return this.teachersCanPublishInput ? 'Allowed' : 'Not Allowed';
    },

    canEditName(): boolean {
      return !this.peerGroup.isGoogleClassroom && !this.peerGroup.isLtiManaged;
    },

    unchanged(): boolean {
      // If validations have errors, do not mark as changed
      if (
        !this.nameValidation.valid ||
        !this.sectionValidation.valid ||
        !this.descriptionValidation.valid
      ) {
        return true;
      }

      if (this.roleNamesAreChanged) {
        return false;
      }

      return (
        this.nameInput === this.peerGroup.name &&
        this.sectionInput === this.peerGroup.section &&
        this.descriptionInput === this.peerGroup.description &&
        this.creatorCanPublishInput == this.peerGroup.creatorCanPublish &&
        this.teachersCanPublishInput == this.peerGroup.teachersCanPublish &&
        this.submissionStatusIsInteractive ==
          this.peerGroup.submissionStatusIsInteractive &&
        this.organizationSyncAssignmentsInput ==
          this.peerGroup.organizationSyncAssignments
      );
    },

    dirtyModel(): UpdatedSettings {
      return {
        peerGroupId: this.peerGroup.peerGroupId,
        name: this.nameInput,
        section: this.sectionInput,
        description: this.descriptionInput,
        creatorCanPublish: this.creatorCanPublishInput,
        teachersCanPublish: this.teachersCanPublishInput,
        submissionStatusIsInteractive: this.submissionStatusIsInteractive,
        organizationSyncAssignments: this.organizationSyncAssignmentsInput,
        roleNameStudent: this.updatedRoleNames.roleNameStudent,
        roleNameStudentPlural: this.updatedRoleNames.roleNameStudentPlural,
        roleNameTeacher: this.updatedRoleNames.roleNameTeacher,
        roleNameTeacherPlural: this.updatedRoleNames.roleNameTeacherPlural
      };
    }
  },

  methods: {
    notifyChanged() {
      this.$emit('settings-changed', {
        dirty: !this.unchanged,
        model: this.dirtyModel
      });
    },

    notifySync() {
      this.$emit('google-sync');
    },

    handleRoleNamesChange({ dirty, outputModel }: RoleNameUpdateEvent) {
      this.roleNamesAreChanged = dirty;
      this.updatedRoleNames = outputModel;

      this.notifyChanged();
    }
  }
});
